import { useState } from 'react';
import { Form, Input, Spinner, Label } from 'reactstrap';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import 'react-datepicker/dist/react-datepicker.css';
import '../../../helpers/datePickerConfig';
import { Search, ChevronDown, ChevronUp, Download } from 'react-feather';
import Table from '../../ui/Table';
import useFormularioRecibos from './hooks/useFormularioRecibos';
import ClearIndicator from './ClearIndicator';
import { estadosReciboOptions, formasPagoOptions, tableColumns } from './constants';
import colors from '../../../theme/colors';

const FormularioRecibos = () => {
  const [showFilters, setShowFilters] = useState(true);
  const {
    formationList,
    isFormSubmittable,
    isTableNotLoading,
    formationCenter,
    fechaInicio,
    fechaFinal,
    fechaError,
    headquarter,
    idRecibo,
    tipoCliente,
    estadoRecibo,
    formaPago,
    data,
    name,
    lastname,
    handleHeadquarter,
    handleClientType,
    handleEstadoRecibo,
    handleFormaPago,
    handleFechaInicio,
    handleFechaFinal,
    handleFormationCenter,
    handleOnSubmit,
    downloadExcel,
    handleNameOnChange,
    handleLastNameOnChange,
    handleIDOnChange,
    loadMore,
    isLoadingMore,
    hasMore,
  } = useFormularioRecibos();

  const toolbarButtons = (
    <>
      <button
        type="submit"
        disabled={!isFormSubmittable || !isTableNotLoading}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 14px',
          fontSize: '0.75rem', fontWeight: 600, borderRadius: '6px', border: 'none',
          backgroundColor: colors.primary, color: '#fff',
          cursor: (!isFormSubmittable || !isTableNotLoading) ? 'not-allowed' : 'pointer',
          opacity: (!isFormSubmittable || !isTableNotLoading) ? 0.5 : 1, transition: 'all 0.15s',
        }}
      >
        {!isTableNotLoading ? <Spinner style={{ height: '13px', width: '13px' }} /> : <Search size={13} />}
        {!isTableNotLoading ? 'Buscando...' : 'Buscar'}
      </button>
      <button
        type="button"
        onClick={downloadExcel}
        disabled={data === '' || !isTableNotLoading}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 10px',
          fontSize: '0.75rem', fontWeight: 600, borderRadius: '6px',
          border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#6b7280',
          cursor: (data === '' || !isTableNotLoading) ? 'not-allowed' : 'pointer',
          opacity: (data === '' || !isTableNotLoading) ? 0.5 : 1, transition: 'all 0.15s',
        }}
      >
        <Download size={13} />
      </button>
    </>
  );

  return (
    <>
      <Form onSubmit={handleOnSubmit}>
        <div style={{
          backgroundColor: '#fff', borderRadius: '12px',
          border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgb(0 0 0 / 0.06)',
          overflow: 'visible',
        }}>
          {/* Toolbar */}
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '12px 16px',
            borderBottom: showFilters ? '1px solid #f3f4f6' : 'none',
          }}>
            <button
              type="button"
              onClick={() => setShowFilters(!showFilters)}
              style={{
                display: 'flex', alignItems: 'center', gap: '6px',
                background: 'none', border: 'none', cursor: 'pointer',
                fontSize: '0.8rem', fontWeight: 600, color: '#374151',
                padding: '4px 8px', borderRadius: '6px',
              }}
            >
              <Search size={15} style={{ color: '#9ca3af' }} />
              Filtros
              {showFilters
                ? <ChevronUp size={14} style={{ color: '#9ca3af' }} />
                : <ChevronDown size={14} style={{ color: '#9ca3af' }} />}
            </button>
            <div style={{ display: 'flex', gap: '8px' }}>
              {toolbarButtons}
            </div>
          </div>

          {/* Filtros colapsables */}
          {showFilters && (
            <div style={{
              padding: '16px',
              opacity: !isTableNotLoading ? 0.5 : 1,
              pointerEvents: !isTableNotLoading ? 'none' : 'auto',
              transition: 'opacity 0.2s',
            }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '12px' }}>
                <div>
                  <label htmlFor="name" className="form-label">Nombre</label>
                  <Input
                    type="text" name="name" id="name" placeholder="Buscar por nombre"
                    onChange={handleNameOnChange} onInput={handleNameOnChange}
                    className={name.error !== '' ? 'border border-danger error' : ''}
                    defaultValue={name.data}
                  />
                </div>
                <div>
                  <label htmlFor="lastname" className="form-label">Apellidos</label>
                  <Input
                    type="text" name="lastname" id="lastname" placeholder="Buscar por apellidos"
                    onChange={handleLastNameOnChange} onInput={handleLastNameOnChange}
                    className={lastname.error !== '' ? 'border border-danger error' : ''}
                    defaultValue={lastname.data}
                  />
                </div>
                <div>
                  <label htmlFor="idRecibo" className="form-label">ID</label>
                  <Input
                    type="text" name="idRecibo" id="idRecibo" placeholder="Buscar por ID"
                    onChange={handleIDOnChange} onInput={handleIDOnChange}
                    className={idRecibo.error !== '' ? 'border border-danger error' : ''}
                    defaultValue={idRecibo.data}
                  />
                </div>
                <div>
                  <label htmlFor="centroFormacion" className="form-label">Centros de estudio</label>
                  <Select
                    options={formationList} closeMenuOnSelect={false} value={formationCenter}
                    isMulti onChange={handleFormationCenter} components={{ ClearIndicator }}
                    placeholder="Seleccionar..."
                  />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '12px' }}>
                <div>
                  <label htmlFor="clientes" className="form-label">Tipo de cliente</label>
                  <select className="form-select" name="clientes" id="clientes" onChange={handleClientType} value={tipoCliente}>
                    <option value="0">Todos</option>
                    <option value="1">Alumno</option>
                    <option value="2">Empresa</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="estadoRecibo" className="form-label">Estado del recibo</label>
                  <Select
                    options={estadosReciboOptions} closeMenuOnSelect={false} value={estadoRecibo}
                    isMulti onChange={handleEstadoRecibo} components={{ ClearIndicator }}
                    placeholder="Seleccionar..."
                  />
                </div>
                <div>
                  <label htmlFor="formaPago" className="form-label">Forma de Pago</label>
                  <Select
                    options={formasPagoOptions} closeMenuOnSelect={false} value={formaPago}
                    isMulti onChange={handleFormaPago} components={{ ClearIndicator }}
                    placeholder="Seleccionar..."
                  />
                </div>
                <div>
                  <Label for="fechaInicio">Fecha de Inicio</Label>
                  <DatePicker
                    id="fechaInicio" name="fechaInicio" selected={fechaInicio}
                    onChange={handleFechaInicio} dateFormat="dd/MM/yyyy" locale="es"
                    className="form-control" disabled={!isTableNotLoading} wrapperClassName="w-100"
                  />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px' }}>
                <div>
                  <Label for="fechaFinal">Fecha Final</Label>
                  <DatePicker
                    id="fechaFinal" name="fechaFinal" selected={fechaFinal}
                    onChange={handleFechaFinal} dateFormat="dd/MM/yyyy" locale="es"
                    className="form-control" disabled={!isTableNotLoading || !fechaInicio}
                    minDate={fechaInicio} wrapperClassName="w-100"
                  />
                  {fechaError && <span className="text-danger tiny">{fechaError}</span>}
                </div>
                <div>
                  <label htmlFor="centros" className="form-label">Empresa</label>
                  <select className="form-select" name="centros" id="centros" onChange={handleHeadquarter} value={headquarter}>
                    <option value="CEDESCA">CEDESCA</option>
                    <option value="CNTEC">CNTEC</option>
                  </select>
                </div>
              </div>
            </div>
          )}
        </div>
      </Form>

      {data !== null && data !== '' && (
        <div style={{ marginTop: '16px' }}>
          <Table
            columns={tableColumns}
            data={data}
            defaultPageSize={10}
            showPaginationBottom
            className="-striped -highlight text-center"
            onLoadMore={loadMore}
            isLoadingMore={isLoadingMore}
            hasMore={hasMore}
          />
        </div>
      )}
    </>
  );
};

export default FormularioRecibos;
